<template>
    

    <div>
        <div v-if="is_super_admin">
            <div style="padding: 0px 16px;">
                <el-button plain type="primary" @click="addFaq" size="small" icon="el-icon-plus">新增常见问题</el-button>
            </div>

            <div style="padding: 10px 16px;">

                <el-table
                :data="faqList"
                style="width: 100%;border-color:'#606266'"
                
                :default-sort = "{prop: 'date', order: 'descending'}"
                :header-cell-style="{background:'#f8f8f8', fontFamily:'Helvetica',fontSize:'14px'}"
                :cell-style="{color: '#666',fontSize:'14px'}"
                border
                >
                
                <el-table-column
                fixed
                align="center"
                prop="faq_id"
                label="常见问题ID"
                sortable
                >
                </el-table-column>

                <el-table-column
                fixed
                align="center"
                prop="faq_name"
                label="问题名称"
                sortable
                >
                </el-table-column>

                <el-table-column
                fixed
                align="center"
                prop="faq_explain"
                label="问题内容"
                sortable
                >
                </el-table-column>

                <el-table-column
                fixed
                align="center"
                prop="faq_image"
                label="图片描述"
                sortable
                >
                    <template slot-scope="scope">
                        <el-image
                        v-if="scope.row.faq_image !== ''"
                        style="width: 100px; height: 100px"
                        :src=scope.row.faq_image
                        :preview-src-list=[scope.row.faq_image]>
                        >
                        </el-image>
                        <el-tag v-else>没有配图</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                align="center"
                label="操作"
                width="100px"
                >
                <template slot-scope="scope">
                    <el-button round icon="el-icon-delete" type="danger" size="small" @click="deleteFaq(scope.row)">删除</el-button>
                </template>
                </el-table-column>

                </el-table>

                <el-pagination
                    @current-change="changeCurrent"
                    :current-page="iCurrentPage"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="iMaxTotal"
                    style="text-align:right; margin-top:15px"
                >
                </el-pagination>
            </div>

            <el-dialog :visible.sync="bShowFaq" :fullscreen="bShowFullscreen" :before-close="this.$dialog_close" :show-close="false">
                <div slot="title" class="dialog-title">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ sDialogNmae }}</span>
                    <el-button icon="el-icon-close" class='dialog-title-button' @click="bShowFaq = false"></el-button>
                    <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="bShowFullscreen = !bShowFullscreen"></el-button>
                </div>

                <el-form :model="dAddFaqFrom" ref="dAddFaqFrom" label-width="100px" @class="demo-dAddFaqFrom">
                    <el-form-item label="问题名称" prop="faq_name" label-width="150px">
                        <el-input v-model="dAddFaqFrom.faq_name" ></el-input>
                    </el-form-item>

                    <el-form-item label="问题内容" prop="faq_explain" label-width="150px">
                        <el-input
                        type="textarea"
                        :autosize="{minRows: 2, maxRows: 15}"
                        placeholder="请输入内容"
                        v-model="dAddFaqFrom.faq_explain">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="问题图片(选传)" prop="faq_image" label-width="150px">
                        <el-upload
                        
                        action= ''
                        list-type="picture-card"
                        ref='upload'
                        :before-remove="removeFaqImg"
                        :limit=1
                        :http-request="uploadFaqImg"
                        :file-list="faqImgList">

                        <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="notAdd">取 消</el-button>
                    <el-button type="primary" @click="addFaqButton">确 定</el-button>
                </div>

            </el-dialog>

        </div>

        <div v-else>
            <div style="text-align: center;">
                <div style="margin-top: 0px;">
                <img src="../assets/permission_denied.png">
                <div style="margin-top: 20px;">
                    <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
                </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
export default {
    name: "FAQSystem",
    data() {
        return {
            faqList: [],
            iCurrentPage: 1,
            iMaxTotal: 10,
            bShowFaq: false,
            bShowFullscreen: false,
            sDialogNmae: '新增问题',
            dAddFaqFrom: {
                faq_explain:''
            },
            faqImgList: [],
            is_super_admin: false,
        };
    },

    mounted() {
        // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
        let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
        if (isSuperAdmin == "false") {
            this.is_super_admin = false
            return
        } else {
            this.is_super_admin = true
        }
        // 请求常见问题
        this.getFaqList()

    },

    methods: {
        // 请求常见问题
        async getFaqList() {
            let d_params = {
                'page': this.iCurrentPage,
                'page_size': 10,
            }
            const res = await this.$axios.get('/api/faq/', {params: d_params});
            this.faqList = res.data.results;
            this.iMaxTotal = res.data.count;

        },

        // 分页事件
        changeCurrent(val){
            this.iCurrentPage = val;
            this.getFaqList();
        },

        // 新增常见问题

        addFaq(){
            this.dAddFaqFrom = {},
            this.bShowFaq = true,
            this.bShowFullscreen = false

        },

        async addFaqButton(){
            let res = await this.$axios.post('/api/faq/', this.dAddFaqFrom);
            this.requestWaring(res)
        },

        // 请求警告
        requestWaring(res){
            if (res.status === 201 || res.status === 200){
            this.$message({
                message: '保存成功',
                type: 'success'
            })
            this.bShowFaq = false
            this.getFaqList()
            
            } else {
            this.$message({
                message: '保存失败',
                type: 'error'
            })
            }
            // 重置数据
            this.resetData()
        },

        // 取消事件
        notAdd(){
            this.bShowFaq = false
            this.resetData()
        },

        // 刷新数据
        resetData(){
            this.dAddFaqFrom = {}
            this.faqImgList = []
        },

        // 上传图片事件
        async uploadFaqImg(option){
            let res = await this.$upload_common(option)
            this.dAddFaqFrom.faq_image = res.data.s_url
        },

        // 删除图片事件
        async removeFaqImg(){
            let sRemoveUrl = this.dAddFaqFrom.faq_image
            await this.$remove_common(sRemoveUrl)
            this.dAddFaqFrom.faq_image = ''
        },

        // 删除操作
        deleteFaq(row){
            var _this = this
            this.$confirm('此操作将永久删除该问题', '删除问题警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'error'
            }).then(() => {
            _this.$axios.delete('/api/faq/' + row.faq_id + '/').then(
                function(res){
                _this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                _this.getFaqList()
                }
            )
            }).catch(() => {
            _this.$message({
                type: 'info',
                message: '已取消删除'
            });          
            });

        },
        

    }

}
</script>

